module.exports = {
  title: 'Time Machine with Reanimated and Skia',
  author: 'Enzo Manuel Mangano',
  date: '2025-06-07',
  slug: 'time-machine',
  tags: ['skia', 'reanimated', 'gesture-handler'],
};
